import { render, staticRenderFns } from "./table-fixed.vue?vue&type=template&id=ba8d4f32&scoped=true"
import script from "./table-fixed.vue?vue&type=script&lang=js"
export * from "./table-fixed.vue?vue&type=script&lang=js"
import style0 from "./table-fixed.vue?vue&type=style&index=0&id=ba8d4f32&prod&lang=less"
import style1 from "./table-fixed.vue?vue&type=style&index=1&id=ba8d4f32&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba8d4f32",
  null
  
)

export default component.exports